import ZohoListingDeskTicketService from '@/services/api/zoho-listing-desk-ticket';

export default class ZohoListingDeskTicketHelper {
  static async formatAndSendZohoTicket(fullListing, type) {
    const ticketData = this.#formatTicketData(fullListing, type);

    await ZohoListingDeskTicketService.createDeskTicket(ticketData);
  }

  static #formatTicketData(fullListing, type) {
    /* eslint-disable camelcase */
    const {
      city,
      state,
      country,
      streetNumber: street_number,
      unit,
      street,
    } = fullListing?.address || '';
    const addressDetails = {
      city,
      state,
      country,
      street_number,
      unit,
      street,
    };
    const listingDetails = fullListing?.listing;

    return {
      type,
      listing: {
        ...listingDetails,
        ...addressDetails,
      },
    };
  }
}
